// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"ec65079a","485":"15692d82"}[chunkId] + ".chunk.css";
};